import { ranking } from '@/mocks/home';

const trendIcon: Record<string, { icon: string; cls: string }> = {
  up: { icon: 'ri-arrow-up-line', cls: 'text-primary-500' },
  down: { icon: 'ri-arrow-down-line', cls: 'text-foreground-400' },
  same: { icon: 'ri-subtract-line', cls: 'text-secondary-500' },
};

export default function Ranking() {
  return (
    <section id="ranking" className="w-full px-4 md:px-8 py-14 md:py-20">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 md:mb-10">
        <div>
          <span className="text-xs font-label text-secondary-600 tracking-[0.2em]">LISTENING CHART</span>
          <h2 className="mt-2 font-heading font-bold text-foreground-950 text-2xl md:text-3xl tracking-tight">
            本周收听榜
          </h2>
          <p className="mt-2 text-sm font-label text-foreground-600 max-w-xl leading-relaxed">
            按近七天播放完成度排序，不只看点开次数，也看有没有人听完。
          </p>
        </div>
        <div className="flex items-center gap-2 text-[11px] font-label text-foreground-500">
          <i className="ri-refresh-line text-secondary-500"></i>
          每日 06:00 重新统计
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-6 gap-y-1">
        {ranking.map((item, index) => {
          const trend = trendIcon[item.trend];
          const top3 = index < 3;
          return (
            <a
              key={item.id}
              href="#hot"
              className="group flex items-center gap-4 py-3.5 border-b border-background-200 cursor-pointer"
            >
              <span
                className={`w-8 h-8 shrink-0 rounded-md flex items-center justify-center font-heading font-bold text-sm ${
                  top3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600'
                }`}
              >
                {index + 1}
              </span>
              <span className="flex flex-col min-w-0 flex-1">
                <span className="text-sm font-label text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                  {item.name}
                </span>
                <span className="text-[11px] font-label text-foreground-500 truncate">{item.meta}</span>
              </span>
              <span className="flex items-center gap-1.5 shrink-0">
                <span className="text-xs font-label text-foreground-600 whitespace-nowrap">{item.listens}</span>
                <i className={`${trend.icon} ${trend.cls} text-sm`}></i>
              </span>
            </a>
          );
        })}
      </div>
    </section>
  );
}